import { Button, Dropdown, Tabs } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { ArchivedCaseListContainer } from "./archived-case-list.container";
import { RelatedCaseListCommonContainer } from "./related-case-list-common.container";
import { ActiveCaseListCommonContainer } from "./active-case-list-common.container";

interface RelatedCasesTabProps {
  handleMenuClick: (e: any) => void; 
  caseId: string;
  selectedId: string | null;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  applicantId: string;
}

export const RelatedCasesTab: React.FC<RelatedCasesTabProps> = (props) => {

  const menuItems = [
    { key: "credential-verification", label: "Credential Verification" },
  ];
  const relatedCasesMenuItems = menuItems.map((item) => {
    return { key: item.key, label: item.label, onClick: props.handleMenuClick };
  });

  const paneTabs = [
    {
      key: '1',
      label: 'Related',
      children: (
        <>
          {/* <RelatedCaseListContainer applicantId={props.applicantId} caseId={props.caseId} setDisabled={props.setDisabled} /> */}
          <RelatedCaseListCommonContainer applicantId={props.applicantId} caseId={props.caseId} setDisabled={() => {}}/>
        </>
      )
    },
    {
      key: '2',
      label: 'Active',
      children: (
        <>
          {/* <ActiveCaseListContainer isVerticalColumn={undefined} applicantId={props.applicantId} caseId={props.caseId} /> */}
          <ActiveCaseListCommonContainer isVerticalColumn={undefined} applicantId={props.applicantId} />
        </>
      )
    },
    {
      key: '3',
      label: 'Archived',
      children: (
        <>
          <ArchivedCaseListContainer caseId={props.caseId} applicantId={props.applicantId} isVerticalColumn={undefined} />
        </>
      )
    }
  ];

  return (
    <>
      <div style={{ marginTop: "-10px" }}>
        <Tabs defaultActiveKey="1" items={paneTabs}/>
      </div>
      <div style={{ marginTop: "16px", textAlign: "right" }}>
      <Dropdown menu={{items: relatedCasesMenuItems}} trigger={['hover']} disabled={true}>
      <Button>
            {props.selectedId ? "Credential Verification" : "Add Related Case"}{" "}
            <DownOutlined />
          </Button>
        </Dropdown>
      </div>
    </>
  );
};
